// e.g. https://maxretail.com or http://localhost:8989 (includes port and protocol)
export const FULL_HOST = `${window.location.protocol}//${window.location.host}`;
export const WINDOW_URL = window.URL || window.webkitURL;
